"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_LEAD_SUBSTAGES = exports.SalesStatusReason = exports.SalesSubstage = exports.SalesStage = void 0;
var SalesStage;
(function (SalesStage) {
    SalesStage["LEAD"] = "LEAD";
    SalesStage["PROSPECT"] = "PROSPECT";
    SalesStage["CLIENT"] = "CLIENT";
})(SalesStage = exports.SalesStage || (exports.SalesStage = {}));
var SalesSubstage;
(function (SalesSubstage) {
    SalesSubstage["NEW"] = "NEW";
    SalesSubstage["CONTACT_CONFIRMED"] = "CONTACT_CONFIRMED";
    SalesSubstage["INITIATED"] = "INITIATED";
    SalesSubstage["QUALIFIED"] = "QUALIFIED";
    SalesSubstage["ALIGNED"] = "ALIGNED";
    SalesSubstage["EXECUTED"] = "EXECUTED";
    SalesSubstage["CLOSED"] = "CLOSED";
})(SalesSubstage = exports.SalesSubstage || (exports.SalesSubstage = {}));
var SalesStatusReason;
(function (SalesStatusReason) {
    /**
     * Stage: LEAD | Substage: NEW | Reserved for now just to reset back into leads.
     */
    SalesStatusReason["RESET"] = "RESET";
    /**
     * Stage: LEAD | Substage: NEW | The opportunity has just been created.
     */
    SalesStatusReason["CREATED"] = "CREATED";
    /**
     * Stage: LEAD | Substage: CONTACT_CONFIRMED | The contact has been confirmed.
     */
    SalesStatusReason["CONTACT_CONFIRMED"] = "CONTACT_CONFIRMED";
    /**
     * Stage: LEAD | Substage: INITIATED
     */
    SalesStatusReason["INITIAL_CALL_SCHEDULED"] = "INITIAL_CALL_SCHEDULED";
    /**
     * Stage: LEAD | Substage: QUALIFIED
     */
    SalesStatusReason["OPPORTUNITIES_CONFIRMED"] = "OPPORTUNITIES_CONFIRMED";
    /**
     * Stage: PROSPECT | Substage: ALIGNED
     */
    SalesStatusReason["NEW_BUSINESS_SUBMITTED"] = "NEW_BUSINESS_SUBMITTED";
    /**
     * Stage: PROSPECT | Substage: ALIGNED
     */
    SalesStatusReason["QUOTING_PLAN_ASSOCIATED"] = "QUOTING_PLAN_ASSOCIATED";
    /**
     * Stage: PROSPECT | Substage: ALIGNED
     */
    SalesStatusReason["PL_COLLABORATION_PLAN_SENT"] = "PL_COLLABORATION_PLAN_SENT";
    /**
     * Stage: PROSPECT | Substage: EXECUTED
     */
    SalesStatusReason["PROPOSAL_DELIVERED"] = "PROPOSAL_DELIVERED";
    /**
     * Stage: CLIENT | Substage: CLOSED
     */
    SalesStatusReason["BOUND_POLICY_ASSOCIATED"] = "BOUND_POLICY_ASSOCIATED";
})(SalesStatusReason = exports.SalesStatusReason || (exports.SalesStatusReason = {}));
exports.ACCOUNT_LEAD_SUBSTAGES = [
    SalesSubstage.NEW,
    SalesSubstage.CONTACT_CONFIRMED,
    SalesSubstage.INITIATED,
];
//# sourceMappingURL=types.js.map